// extracted by mini-css-extract-plugin
export default {"fields":"qry21f","fieldsGroup":"PcfqZ3","accessLevelLeftGroup":"w95WYD","accessProjectsDropdown":"M5tgrR","accessPermissionsDropdown":"RnDnRY"};